<template>
  <div v-loading="loading">
    <Header/>
    <section class="main">
      <div class="container">
        <div class="main__header">
          <h1 class="main__title--m0">
            Transaction details
          </h1>
        </div>
        <div class="transaction__details details">
          <div class="details__items">
            <div class="details__item">
              <div class="details__termin">Block</div>
              <div class="details__definition">
                <div class="details__definition-purse">
                  <a href="#">{{tableData.block}}</a>
                </div>
                <div class="details__definition-label">{{tableData.confirmations}} block confirmation</div>
              </div>
            </div>
            <div class="details__item">
              <div class="details__termin">Hash</div>
              <div class="details__definition">
                <div class="details__definition-purse">
                  <router-link :to="'/tx/' + tableData.hash" id="hash_detail">{{tableData.hash}}</router-link>
                </div>
                <div class="details__definition-copy">
                  <a
                    v-clipboard:success="copy_success"
                    v-clipboard="() => tableData.hash"
                    class="copy__link">
                    <ion-icon name="copy" class="copy"></ion-icon>
                  </a>
                </div>
              </div>
            </div>
            <div class="details__item">
              <div class="details__termin">Sender</div>
              <div class="details__definition">
                <div class="details__definition-purse">
                  <router-link  :to="'/address/' + tableData.sender + '/tx/1'" id="sender_detail">{{tableData.sender}}</router-link>
                </div>
                <div class="details__definition-copy">
                  <a
                    v-clipboard:success="copy_success"
                    v-clipboard="() => tableData.sender"
                    class="copy">
                    <ion-icon name="copy" class="copy"></ion-icon>
                  </a>
                </div>
              </div>
            </div>
            <div class="details__item">
              <div class="details__termin">Recipient</div>
              <div class="details__definition">
                <div class="details__definition-purse">
                  <router-link
                    :to="'/address/' + tableData.recipient + '/tx/1'" id="recipient_detail">{{tableData.recipient}}</router-link>
                </div>
                <div class="details__definition-good">
                  <i class="ion-checkmark-circled check"></i>
                </div>
                <div class="details__definition-copy">
                  <a class="copy"
                     v-clipboard:success="copy_success"
                     v-clipboard="() => tableData.recipient"
                  >
                    <ion-icon name="copy" class="copy"></ion-icon>
                  </a>
                </div>
              </div>
            </div>
            <div class="details__item">
              <div class="details__termin">Amount</div>
              <div class="details__definition">{{tableData.amount}}</div>
            </div>
            <div class="details__item">
              <div class="details__termin">Fee</div>
              <div class="details__definition">{{tableData.fee}}</div>
            </div>
            <div class="details__item">
              <div class="details__termin">Timestamp</div>
              <div class="details__definition">{{tableData.timestamp}}</div>
              <div class="warning">Deadline: {{tableData.deadline}}</div>
            </div>
            <div class="details__item">
              <div class="details__termin">Signature</div>
              <div class="details__definition">
                <p style="margin-left: 26px;">{{tableData.signature}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer/>

  </div>
</template>

<script>
  import Header from '../components/Header';
  import TxProxy from '../../proxies/TxProxy';
  import moment from 'moment';
  import { divisibility } from '../../utils/Math_util';
  import Footer from '../components/Footer';
  import Axios from 'axios';
  import { copy_success } from '../../utils/copy';

  export default {
    name: 'Index',
    components: {
      Footer,
      Header
    },
    async mounted() {
      try {

        const nemEpoch = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
        Axios.get('http://109.203.100.51:7890/chain/height')
          .then(async (response) => {
            response = response.data;
            const tx_proxy = new TxProxy();
            const tx_info = await tx_proxy.get_tx_info({
              height: null,
              hash: this.$route.params.hash
            });

            if (tx_info.tx.mosaics[0].mosaicId.namespaceId !== 'arus') new Error('not found');
            const confirmations =  response.height - tx_info.height;
            this.tableData = {
              block: tx_info.height,
              hash: this.$route.params.hash,
              sender: tx_info.tx.signerAccount,
              recipient: tx_info.tx.recipient,
              amount: divisibility(tx_info.tx.mosaics[0].quantity, tx_info.tx.mosaics[0].divisibility) + ' ' + tx_info.tx.mosaics[0].mosaicId.name,
              fee: divisibility(tx_info.tx.fee) + ' XEM',
              timestamp: moment(new Date(nemEpoch + (tx_info.tx.timeStamp * 1000)))
                .format('DD.MM.YYYY, HH:mm:ss'),
              signature: tx_info.tx.signature,
              deadline: moment(new Date(nemEpoch + (tx_info.tx.deadline * 1000)))
                .format('DD.MM.YYYY, HH:mm:ss'),
              confirmations: confirmations > 32 ? '32+' : confirmations
            };
            this.loading = false;
          });

      } catch (e) {
        this.$router.push('/404');
      }
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex & 1 ? 'odd-row' : 'bdd-row';
      },
    },
    data: function () {
      return {
        loading: true,
        tableData: [],
        copy_success
      };
    }
  };
</script>

<style scoped>
  .main {
    margin-top: 50px;
  }

  .table-tx {
    margin-top: 20px;
  }
</style>
